export function parseError(error) {
    if (!error)
        return String(error);
    const { stack, name, message } = error;
    if (stack)
        return `${message}: ${name}\n${stack}`;
    if (message)
        return `${message}${name}`;
    return error.toString();
}
